































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'FixRequestUploader'
})
export default class extends Vue {
  @Prop({ default: '' }) private value!: string
  @Prop({ default: '' }) private url!: string
  imageData: string

  get imageUrl() {
    return this.url || ''
  }

  setImageUrl(value: string) {
    this.url = value
  }

  handleRequest() {
    console.log('in handle Request()')
  }

  private async handleBeforeUpload(file: File) {
    this.$emit('input', file)
    const imageUrl = URL.createObjectURL(file)
    this.setImageUrl(imageUrl)
    // URL.revokeObjectURL(imageUrl)
  }

  private rmImage() {
    this.setImageUrl('')
  }
}
